export function transformCustomStages(stages: PipelineStage[]): AddStageData[] {
  return stages.map((stage) => ({
    id: stage.id,
    name: stage.name,
    requireEvaluation: stage.requireEvaluation,
    requireReason: stage.requireReason,
  }));
}
